function convertJsonOfUpComingGpsCoordinates(question: any) {
  const {
    centerPoint,
    center_point,
    mapCenterPoint: existingMapCenterPoint,
    id,
    title,
    type,
    name,
    description,
    isRequired,
    visible,
    zoomLevel,
    zoom_level,
  } = question;

  const resolvedCenterPoint = centerPoint ?? center_point;
  const mapCenterPoint = {
    doFly: existingMapCenterPoint?.doFly ?? false,
    longitude:
      resolvedCenterPoint?.[0] ?? existingMapCenterPoint?.longitude ?? "",
    latitude: resolvedCenterPoint?.[1] ?? existingMapCenterPoint?.latitude ?? "",
  };

  const structuredData = {
    _id: id,
    name,
    title,
    type,
    description,
    isRequired: isRequired ?? false,
    visible: visible ?? true,
    zoomLevel: zoomLevel ?? zoom_level ?? 2,
    mapCenterPoint,
  };

  return structuredData;
}

export { convertJsonOfUpComingGpsCoordinates };
